import * as React from 'react'

const SvgAwardOrangeIcon = (props) => (
  <svg
    width="56"
    height="57"
    viewBox="0 0 56 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_4420_105229)">
      <rect x="12" y="0.549805" width="32" height="32" rx="8" fill="#FF692E" />
      <path
        d="M25.2458 18.8561L24.6667 23.2161L27.7256 21.3808C27.8254 21.3209 27.8753 21.291 27.9285 21.2793C27.9756 21.269 28.0244 21.269 28.0715 21.2793C28.1247 21.291 28.1746 21.3209 28.2744 21.3808L31.3333 23.2161L30.7546 18.8542M30.9506 11.3821C31.0536 11.6311 31.2512 11.829 31.5 11.9323L32.3726 12.2938C32.6216 12.397 32.8195 12.5948 32.9226 12.8438C33.0258 13.0929 33.0258 13.3727 32.9226 13.6217L32.5615 14.4937C32.4583 14.7429 32.4581 15.023 32.5618 15.272L32.9223 16.1437C32.9735 16.2671 32.9998 16.3993 32.9998 16.5328C32.9998 16.6663 32.9736 16.7985 32.9225 16.9219C32.8714 17.0452 32.7965 17.1573 32.702 17.2517C32.6076 17.3461 32.4955 17.421 32.3721 17.4721L31.5002 17.8332C31.2512 17.9362 31.0532 18.1338 30.9499 18.3827L30.5885 19.2553C30.4853 19.5044 30.2875 19.7022 30.0385 19.8054C29.7894 19.9085 29.5096 19.9085 29.2606 19.8054L28.3886 19.4442C28.1396 19.3413 27.8599 19.3415 27.611 19.4448L26.7384 19.8057C26.4896 19.9086 26.21 19.9085 25.9612 19.8054C25.7124 19.7024 25.5146 19.5048 25.4114 19.256L25.0499 18.3831C24.9469 18.1341 24.7493 17.9362 24.5004 17.8328L23.6278 17.4714C23.3789 17.3683 23.1811 17.1705 23.0779 16.9216C22.9748 16.6728 22.9746 16.3931 23.0776 16.1441L23.4387 15.2721C23.5416 15.023 23.5414 14.7433 23.4381 14.4945L23.0775 13.6212C23.0264 13.4979 23 13.3657 23 13.2321C23 13.0986 23.0263 12.9664 23.0774 12.843C23.1285 12.7197 23.2034 12.6076 23.2978 12.5132C23.3922 12.4188 23.5043 12.3439 23.6277 12.2929L24.4996 11.9317C24.7484 11.8288 24.9462 11.6314 25.0497 11.3828L25.4111 10.5102C25.5142 10.2612 25.7121 10.0633 25.9611 9.96018C26.2101 9.85702 26.4899 9.85702 26.739 9.96018L27.6109 10.3214C27.86 10.4243 28.1397 10.4241 28.3885 10.3208L29.2615 9.96074C29.5105 9.85764 29.7902 9.85766 30.0392 9.9608C30.2882 10.0639 30.486 10.2617 30.5892 10.5107L30.9507 11.3836L30.9506 11.3821Z"
        stroke="white"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_4420_105229"
        x="0"
        y="0.549805"
        width="56"
        height="56"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="12"
          operator="erode"
          in="SourceAlpha"
          result="effect1_dropShadow_4420_105229"
        />
        <feOffset dy="12" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.411765 0 0 0 0 0.180392 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4420_105229"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4420_105229"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

export default SvgAwardOrangeIcon
